import useNotificationCount from './use-notification-count';

export default { useNotificationCount };

export { useNotificationCount };
